import React from 'react';
import './style.css';

// Splits off the final word (the name) so it can render as a gradient accent,
// matching the approved design — works for both "Hi, I'm Raul" and "Hola, soy Raul".
const FadeUpTitle = ({ text }) => {
  const trimmed = text.trim();
  const lastSpace = trimmed.lastIndexOf(' ');
  const lead = lastSpace === -1 ? '' : trimmed.slice(0, lastSpace + 1);
  const accent = lastSpace === -1 ? trimmed : trimmed.slice(lastSpace + 1);

  let charIndex = 0;
  const renderLetters = (str, isAccent) =>
    str.split('').map((char) => {
      const key = charIndex;
      const delay = `${charIndex * 0.1}s`;
      charIndex += 1;
      return (
        <span
          key={key}
          className={isAccent ? 'letter letter-accent' : 'letter'}
          style={{ animationDelay: delay }}
        >
          {char === ' ' ? ' ' : char}
        </span>
      );
    });

  return (
    <h1
      className='mt-6 max-w-3xl text-5xl font-bold leading-[0.98] tracking-[-0.02em] text-[var(--text-main)] md:text-7xl'
      style={{ fontFamily: 'var(--font-display)' }}
    >
      {renderLetters(lead, false)}
      {renderLetters(accent, true)}
    </h1>
  );
};

export default FadeUpTitle;
